(function () {
  'use strict';

  const defaults = {
    title: 'Are you sure?',
    titleClass: 'modal-title',
    titleElement: 'h5',
    commit: 'Confirm',
    commitClass: 'btn-danger',
    cancel: 'Cancel',
    cancelClass: 'btn-secondary',
    fade: true,
    verifyClass: 'form-control',
    elements: ['a[data-confirm]', 'button[data-confirm]', 'input[type=submit][data-confirm]'],
    focus: 'commit',
    zIndex: 1050,
    modalClass: '',
    dialogClass: ''
  };

  let settings;

  window.dataConfirmModal = {
    setDefaults(newSettings) {
      settings = Object.assign({}, settings, newSettings);
    },

    restoreDefaults() {
      settings = Object.assign({}, defaults);
    },

    confirm(options) {
      const modal = buildModal(options);

      modal.spawn();
      modal.addEventListener('hidden.bs.modal', function () {
        modal.remove();
      });

      modal.querySelector('.commit').addEventListener('click', function () {
        if (options.onConfirm && typeof options.onConfirm === 'function') {
          options.onConfirm.call();
        }

        if (modal.bootstrapModal) {
          modal.bootstrapModal.hide();
        }
      });

      modal.querySelector('.cancel').addEventListener('click', function () {
        if (options.onCancel && typeof options.onCancel === 'function') {
          options.onCancel.call();
        }

        if (modal.bootstrapModal) {
          modal.bootstrapModal.hide();
        }
      });

      modal.addEventListener('hidden.bs.modal', function () {
        if (options.onHide && typeof options.onHide === 'function') {
          options.onHide.call();
        }
      });
    }
  };

  dataConfirmModal.restoreDefaults();

  const getData = (element, key) => {
    return element.dataset[key] || element.getAttribute(key) || element.getAttribute(`data-${key}`);
  };

  const buildElementModal = function (element) {
    const options = {
      title:             getData(element, 'title') || element.getAttribute('title') || getData(element, 'original-title'),
      titleClass:        getData(element, 'titleClass'),
      titleElement:      getData(element, 'titleElement'),
      text:              getData(element, 'confirm'),
      focus:             getData(element, 'focus'),
      method:            getData(element, 'method'),
      modalClass:        getData(element, 'modalClass'),
      dialogClass:       getData(element, 'dialogClass'),
      commit:            getData(element, 'commit'),
      commitClass:       getData(element, 'commitClass'),
      cancel:            getData(element, 'cancel'),
      cancelClass:       getData(element, 'cancelClass'),
      remote:            getData(element, 'remote'),
      verify:            getData(element, 'verify'),
      verifyRegexp:      getData(element, 'verifyRegexp'),
      verifyLabel:       getData(element, 'verifyText'),
      verifyRegexpCaseInsensitive: getData(element, 'verifyRegexpCaseinsensitive')
    };

    const modal = buildModal(options);

    modal.querySelector('.commit').addEventListener('click', function () {
      // Remove the data-confirm attribute temporarily to allow the action to proceed
      const originalConfirm = getData(element, 'confirm');
      element.removeAttribute('data-confirm');

      if (element.tagName === 'FORM') {
        element.submit();
      } else if (element.tagName === 'INPUT' && element.form) {
        element.form.submit();
      } else {
        element.click();
      }

      // Restore data-confirm after a brief delay
      setTimeout(() => {
        element.setAttribute('data-confirm', originalConfirm);
      }, 100);

      if (modal.bootstrapModal) {
        modal.bootstrapModal.hide();
      }
    });

    return modal;
  };

  const buildModal = function (options) {
    const id = `confirm-modal-${String(Math.random()).slice(2, -1)}`;
    const fade = settings.fade ? 'fade' : '';
    const titleClass = options.titleClass || settings.titleClass;
    const titleElement = options.titleElement || settings.titleElement;
    const modalClass = options.modalClass || settings.modalClass;
    const dialogClass = options.dialogClass || settings.dialogClass;

    const modalClose = `<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>`;
    const modalTitle = `<${titleElement} id="${id}Label" class="${titleClass}"></${titleElement}>`;

    const modalHTML =
      `<div id="${id}" class="modal ${modalClass} ${fade}" tabindex="-1" aria-labelledby="${id}Label" aria-hidden="true">` +
        `<div class="modal-dialog modal-dialog-centered ${dialogClass}">` +
          '<div class="modal-content">' +
            '<div class="modal-header">' +
              modalTitle +
              modalClose +
            '</div>' +
            '<div class="modal-body"></div>' +
            '<div class="modal-footer">' +
              '<button class="btn cancel" data-bs-dismiss="modal"></button>' +
              '<button class="btn commit"></button>' +
            '</div>'+
          '</div>'+
        '</div>'+
      '</div>';

    const wrapper = document.createElement('div');
    wrapper.innerHTML = modalHTML;
    const modal = wrapper.firstElementChild;

    // Handle z-index stacking for multiple modals
    let highest = settings.zIndex;
    document.querySelectorAll('.modal.show').forEach(function(el) {
      if (el.id !== id) {
        const current = parseInt(window.getComputedStyle(el).zIndex, 10);
        if(current > highest) {
          highest = current;
        }
      }
    });
    modal.style.zIndex = parseInt(highest) + 1;

    modal.querySelector('.modal-title').textContent = options.title || settings.title;

    const body = modal.querySelector('.modal-body');

    (options.text || '').split(/\n{2}/).forEach(function (piece) {
      const p = document.createElement('p');
      p.innerHTML = piece;
      body.appendChild(p);
    });

    const commit = modal.querySelector('.commit');
    commit.textContent = options.commit || settings.commit;
    commit.className += ' ' + (options.commitClass || settings.commitClass);

    const cancel = modal.querySelector('.cancel');
    cancel.textContent = options.cancel || settings.cancel;
    cancel.className += ' ' + (options.cancelClass || settings.cancelClass);

    if (options.remote) {
      commit.setAttribute('data-bs-dismiss', 'modal');
    }

    if (options.verify || options.verifyRegexp) {
      commit.disabled = true;

      let isMatch;
      if (options.verifyRegexp) {
        const caseInsensitive = options.verifyRegexpCaseInsensitive;
        const regexp = options.verifyRegexp;
        const re = new RegExp(regexp, caseInsensitive ? 'i' : '');

        isMatch = function (input) { return input.match(re); };
      } else {
        isMatch = function (input) { return options.verify === input; };
      }

      const verification = document.createElement('input');
      verification.type = 'text';
      verification.className = settings.verifyClass;
      verification.addEventListener('keyup', function () {
        commit.disabled = !isMatch(this.value);
      });

      modal.addEventListener('shown.bs.modal', function () {
        verification.focus();
      });

      modal.addEventListener('hidden.bs.modal', function () {
        verification.value = '';
        verification.dispatchEvent(new Event('keyup'));
      });

      if (options.verifyLabel) {
        const label = document.createElement('p');
        label.textContent = options.verifyLabel;
        body.appendChild(label);
      }

      body.appendChild(verification);
    }

    let focus_element;
    if (options.focus) {
      focus_element = options.focus;
    } else if (options.method === 'delete') {
      focus_element = 'cancel';
    } else {
      focus_element = settings.focus;
    }
    focus_element = modal.querySelector('.' + focus_element);

    modal.addEventListener('shown.bs.modal', function () {
      focus_element.focus();
    });

    document.body.appendChild(modal);

    modal.spawn = function() {
      const bootstrapModal = new bootstrap.Modal(modal);
      bootstrapModal.show();
      modal.bootstrapModal = bootstrapModal;
      return modal;
    };

    return modal;
  };

  const getConfirmModal = function (element) {
    let modal = element._confirmModal;

    if (!modal || !document.body.contains(modal)) {
      modal = buildElementModal(element);
      element._confirmModal = modal;

      // Clean up modal and cache when hidden
      modal.addEventListener('hidden.bs.modal', function () {
        modal.remove();
        delete element._confirmModal;
      });
    }

    return modal;
  };

  const confirmModal = function (element) {
    const modal = getConfirmModal(element);
    modal.spawn();
    return modal;
  };

  // Rails UJS integration - deferred because Webpack hoists imports
  // above inline code, so window.Rails isn't set at module load time
  function setupRailsConfirm() {
    if (window.Rails) {
      Rails.confirm = function(message, element) {
        if (!element || !settings.elements.some(selector => element.matches(selector))) {
          return window.confirm(message);
        }

        confirmModal(element);
        return false;
      };
    }
  }

  setupRailsConfirm();
  if (!window.Rails) {
    document.addEventListener('DOMContentLoaded', setupRailsConfirm);
  }
})();

document.addEventListener('initialize', function() {
  if (typeof dataConfirmModal !== 'undefined') {
    dataConfirmModal.setDefaults({
      title: "Anfrage senden",
      backdrop: 'static',
      keyboard: false,
      commit: $(".confirm-modal").data("commit"),
      cancel: $(".confirm-modal").data("cancel")
    });
  }
});